module.exports = __webpack_public_path__ + "static/img/rong2.6480688.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/rong2.jpg
// module id = e3+j
// module chunks = 52